import { BooleanInput } from '@angular/cdk/coercion';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-opcoes',
  templateUrl: './opcoes.component.html',
  styleUrls: ['./opcoes.component.css']
})
export class OpcoesComponent implements OnInit {

  @Input() opcoes: Array<any> = []
  @Input() formulario: UntypedFormGroup;
  @Input() nomeControle: string;
  @Input() identificacao: string;
  @Input() requerido: BooleanInput = false;
  @Input() textoAjuda: string;
  @Input() danger: boolean = false;

  constructor() { }

  ngOnInit(): void {
    // Inicializa o FormControl se necessário
    if (this.formulario && this.nomeControle && !this.formulario.controls[this.nomeControle]) {
      this.formulario.addControl(this.nomeControle, new UntypedFormControl(null));
    }
  }

  onSelectionChange(event: any) {
    const selectedValue = event?.value;
    console.log(`Selected value: ${selectedValue}`);
    console.log(`Selected value: ${this.nomeControle}`);
    this.formulario?.get(this.nomeControle)?.setValue(selectedValue);
    console.log(`Selected value: ${this.nomeControle}`);
  }

}
